import baseProps from './ChoosePlacementForAddOnDataProvider.props';

export default {
	...baseProps,
	placements: { type: Array },
	contexts: { type: Array }, // contexts of the received placements
	generalPlacements: { type: Array },
	service: { type: Object },
	tilesAreActive: { type: Boolean },
	useSingletonPlacements: { type: Boolean },
};
